/**
 * Determines if the argument is object-like.
 *
 * A value is object-like if it's not `null` and has a `typeof` result of "object".
 *
 * @param  {*} x - The value to be checked.
 * @return {boolean}
 */

const isObject = x => (x && typeof x === 'object')

/**
 * Determines if the device is a touch device.
 * @return {boolean}
 */
const isTouchDevice = () => {
    document.documentElement.classList.toggle(
        'is-touch-device',
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
};

/**
 * Determines if the argument is a function.
 *
 * @param  {*} x - The value to be checked.
 * @return {boolean}
 */

const isFunction = x => typeof x === 'function'

const isFirefox = () => {
    document.documentElement.classList.toggle(
        'is-firefox',
        navigator.userAgent.indexOf('Firefox') != -1
    );
}

const isSafari = () => {
    document.documentElement.classList.toggle(
        'is-safari',
        navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Version') != -1
    );
}

const isAndroid = () => {
    document.documentElement.classList.toggle(
        'is-android',
        navigator.userAgent.indexOf('Android') != -1
    );
}

let localStorageAvailable = null;
let sessionStorageAvailable = null;

const isLocalStorageAvailable = () => {
    return localStorageAvailable ??= isStorageAvailable(window.localStorage);
}

const isSessionStorageAvailable = () => {
    return sessionStorageAvailable ??= isStorageAvailable(window.sessionStorage);
}

const isAccessibility = () => {
    if (typeof localStorage.getItem("a11y") === 'undefined' || localStorage.getItem("a11y") === null) {
        localStorage.setItem("a11y", "standard");
    } else {
        if (localStorage.getItem("a11y") === "light") {
            document.documentElement.dataset.theme = "light"
        } else if (localStorage.getItem("a11y") === "standard") {
            document.documentElement.dataset.theme = "standard"
        }
    }
}

function isStorageAvailable(storage) {
    try {
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (error) {
        return error instanceof DOMException && (
            // everything except Firefox
            error.code === 22 ||
            // Firefox
            error.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            error.name === 'QuotaExceededError' ||
            // Firefox
            error.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};

export {
    isObject,
    isFunction,
    isTouchDevice,
    isFirefox,
    isSafari,
    isAndroid,
    isAccessibility,
    isLocalStorageAvailable,
    isSessionStorageAvailable
}
